<script>
// Sectioned card used inside panels/pages: icon chip + title + hint on the
// left, optional `aside` slot (counter, status pill) on the right, content
// below.
export default {
  name: 'PanelCard',
  props: {
    title: { type: String, default: '' },
    hint: { type: String, default: '' },
    plainIcon: { type: Boolean, default: false },
  },
  computed: {
    hasHead() {
      return !!(this.title || this.hint || this.$slots.icon || this.$slots.aside);
    },
  },
};
</script>

<template>
  <section class="panel-card">
    <div v-if="hasHead" class="panel-card__head">
      <div class="tw-flex tw-items-center tw-gap-3 tw-min-w-0">
        <span v-if="$slots.icon" class="panel-card__icon" :class="{ 'panel-card__icon--plain': plainIcon }">
          <slot name="icon" />
        </span>
        <div class="tw-min-w-0">
          <div v-if="title" class="panel-card__title">{{ title }}</div>
          <div v-if="hint" class="panel-card__hint">{{ hint }}</div>
        </div>
      </div>
      <slot name="aside" />
    </div>

    <slot />
  </section>
</template>

<style lang="scss">
.panel-card {
  border: 1px solid $color_border;
  border-radius: 14px;
  padding: 1rem;

  &__head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 0.75rem;
    margin-bottom: 0.85rem;
  }

  &__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    border-radius: 10px;
    background: rgba($color_primary, 0.08);
    color: $color_primary;
    flex-shrink: 0;

    &--plain {
      background: $color_light_bg;
    }
  }

  &__title {
    font-size: 0.92rem;
    font-weight: 700;
    color: $color_text;
    line-height: 1.2;
  }

  &__hint {
    font-size: 0.75rem;
    color: $color_primary_muted;
    margin-top: 2px;
  }
}
</style>
